export const VARIANTS_RESET_STATE = 'VARIANTS_RESET_STATE';
export const VARIANTS_CURRENT_ITEM = 'VARIANTS_CURRENT_ITEM';

export const VARIANTS_REQUEST_LOADING = 'VARIANTS_REQUEST_LOADING';
export const VARIANTS_REQUEST_SUCCESS = 'VARIANTS_REQUEST_SUCCESS';
export const VARIANTS_REQUEST_FAILED = 'VARIANTS_REQUEST_FAILED';

export const VARIANTS_CURRENT_ACTION = 'VARIANTS_CURRENT_ACTION';
export const VARIANTS_RESET_ACTION = 'VARIANTS_RESET_ACTION';